var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVisibility(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2808_6836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 16C7.82994 16 3.78994 13.81 0.639941 9.83C-0.210059 8.75 -0.210059 7.25 0.639941 6.17C3.78994 2.19 7.82994 0 11.9999 0C16.1699 0 20.2099 2.19 23.3599 6.17C24.2099 7.25 24.2099 8.75 23.3599 9.83C20.2099 13.81 16.1699 16 11.9999 16ZM11.9999 2C8.48994 2 5.03994 3.91 2.28994 7.38C1.99994 7.74 1.99994 8.25 2.28994 8.62C5.03994 12.09 8.48994 14 11.9999 14C15.5099 14 18.9599 12.09 21.7099 8.62C21.9999 8.26 21.9999 7.75 21.7099 7.38C18.9599 3.91 15.5099 2 11.9999 2Z",
    fill: "#5E5C67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46006 11.5398C10.4101 13.4898 13.5801 13.4898 15.5301 11.5398C17.4801 9.58982 17.4801 6.41982 15.5301 4.46982C13.5801 2.51982 10.4101 2.51982 8.46006 4.46982C6.51006 6.41982 6.51006 9.58982 8.46006 11.5398Z",
    fill: "#5E5C67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2808_6836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibility);
export default __webpack_public_path__ + "static/media/icon_visibility.8c30ff20eb53a6b42a768037fc6e5653.svg";
export { ForwardRef as ReactComponent };